import type { ReactNode } from "react";
import styles from "./choice-field.module.css";

/**
 * A visible question over a choice that only names itself to screen readers (Arc's
 * SegmentedControl and RadioCards take an aria-only label). The control keeps its own label; the
 * text here is the same words for sighted people, so it's hidden from assistive tech.
 */
export function ChoiceField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className={styles.field}>
      <span className={styles.label} aria-hidden="true">
        {label}
      </span>
      {children}
    </div>
  );
}
